/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Audio_CheckInputs */



/**
* | output |
* | --- |
* | "Audio" |
*
* @param {Practice_Session_Audio_CheckInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_audio_check = /** @type {((inputs?: Practice_Session_Audio_CheckInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Audio_CheckInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Audio")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Audio")
	return /** @type {LocalizedString} */ ("Audio")
});